<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   width="24"
   height="25"
   viewBox="0 0 24 25"
   fill="none"
   version="1.1"
   id="svg4"
   sodipodi:docname="subscriptions.svg"
   inkscape:version="1.3.2 (091e20ef0f, 2023-11-25, custom)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs4" />
  <sodipodi:namedview
     id="namedview4"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:zoom="29.48"
     inkscape:cx="12.008141"
     inkscape:cy="12.483039"
     inkscape:window-width="1916"
     inkscape:window-height="1036"
     inkscape:window-x="0"
     inkscape:window-y="0"
     inkscape:window-maximized="0"
     inkscape:current-layer="svg4" />
  <path
     d="M 3.9,6.6339205 H 20.1"
     stroke="currentColor"
     stroke-width="1.8"
     stroke-linecap="round"
     id="path1" />
  <path
     d="M 6.6,3.0207985 H 17.4"
     stroke="currentColor"
     stroke-width="1.8"
     stroke-linecap="round"
     id="path2" />
  <path
     d="M 3.741177,10.295832 H 20.25885 c 0.88119,0 1.64115,0.74376 1.64115,1.71819 v 9.16362 c 0,0.97443 -0.75996,1.71819 -1.64115,1.71819 H 3.741177 C 2.859915,22.895832 2.1,22.152072 2.1,21.177642 v -9.16362 c 0,-0.97443 0.759915,-1.71819 1.641177,-1.71819 z"
     stroke="currentColor"
     stroke-width="1.8"
     id="path3" />
  <path
     d="m 9.3,13.583172 v 6.3 l 5.4,-3.149461 z"
     fill="currentColor"
     id="path4"
     style="stroke-width:0.9" />
</svg>
